import { render, staticRenderFns } from "./Teen9.vue?vue&type=template&id=534af39d&scoped=true&"
import script from "./Teen9.vue?vue&type=script&lang=js&"
export * from "./Teen9.vue?vue&type=script&lang=js&"
import style0 from "./Teen9.vue?vue&type=style&index=0&id=534af39d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534af39d",
  null
  
)

export default component.exports